import { motion } from 'framer-motion';

const FadeUpParagraph: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = props => {
  return (
    <motion.p
      className={props.className}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut', delay: 0.1 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      {props.children}
    </motion.p>
  );
};

export default FadeUpParagraph;
